import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";

const FAQS = [
    {
        q: "কাপড় কি ১০০% খাদি কটন?",
        a: "হ্যাঁ, এই পাঞ্জাবি তৈরি কুমিল্লার অরিজিনাল ১০০% খাদি কটন দিয়ে। কাপড় নরম ও breathable, সারাদিন পরার উপযোগী।",
    },
    {
        q: "কী কী colour ও size পাওয়া যায়?",
        a: "৩টি রং পাওয়া যাচ্ছে — ক্রিম, সাদা ও কালো। সাইজ: 40 (M), 42 (L), 44 (XL) এবং 46 (XXL)। প্রতিটি রঙের অধীনে চারটি সাইজই উপলব্ধ।",
    },
    {
        q: "দুটি বা তিনটি নিলে কত টাকা লাগবে?",
                a: "১টি পাঞ্জাবি ৳৯০০ (রেগুলার ৳১,৩০০)। যেকোনো ২টি পাঞ্জাবি ৳১,৭০০। ৩টি পাঞ্জাবি মাত্র ৳২,৫০০ — সঙ্গে সম্পূর্ণ ফ্রি ডেলিভারি। রং বা সাইজ যেকোনোটি বেছে নিতে পারবেন।",
    },
    {
        q: "Delivery charge কত?",
        a: "ঢাকা শহরের ভেতরে ৳৭০ এবং ঢাকার বাইরে ৳১৩০। ৩টি পাঞ্জাবির প্যাকেজে ডেলিভারি চার্জ সম্পূর্ণ ফ্রি।",
    },
    {
        q: "COD কীভাবে কাজ করে?",
        a: "ক্যাশ অন ডেলিভারিতে পণ্য হাতে পাওয়ার সময় মূল্য পরিশোধ করবেন। কোনো অগ্রিম পেমেন্ট লাগবে না।",
    },
    {
        q: "অর্ডারের পর কী হবে?",
        a: "অর্ডারের পর আমাদের কাস্টমার কেয়ার প্রতিনিধি আপনার দেওয়া মোবাইল নম্বরে ফোন করে পণ্যের বিবরণ, ডেলিভারি চার্জ ও মোট মূল্য নিশ্চিত করবেন। এরপর পণ্য পাঠানো হবে।",
    },
    {
        q: "Size না মিললে কী করব?",
        a: "সাইজ না মিললে কাস্টমার কেয়ারের সঙ্গে যোগাযোগ করুন — এক্সচেঞ্জ বা রিটার্নের সমাধান করে দেওয়া হবে।",
    },
    {
        q: "ছবি ও বাস্তব পণ্যের রঙে পার্থক্য হতে পারে কি?",
        a: "আলো বা ডিসপ্লের কারণে ছবির সঙ্গে বাস্তব পণ্যের রঙে সামান্য পার্থক্য হতে পারে। তবে রং ও কোয়ালিটির বিষয়ে আমরা অ্যাশিউরেন্স দিই।",
    },
];

export default function FAQ() {
    return (
        <section id="faq" className="bg-[#FBF9F5] py-12 md:py-24 scroll-mt-[4.25rem]">
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <Reveal className="text-center mb-10">
                    <p className="text-sm font-semibold text-[#A84320] tracking-wide mb-2">সাধারণ জিজ্ঞাসা</p>
                    <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1E1B18]">
                        আপনার প্রশ্নের উত্তর
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                data-testid="faq-accordion-item"
                                className="border border-[#E4DDD3] bg-white rounded-xl mb-3 px-5 overflow-hidden"
                            >
                                <AccordionTrigger className="text-left text-base font-semibold text-[#1E1B18] hover:no-underline py-4">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm text-[#4A453F] leading-relaxed pb-4">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
